import { z } from 'zod';

/** Keep the restricted portal explicit; never fall back to Stripe's default. */
export const billingPortalConfigurationIdSchema = z
  .string()
  .trim()
  .regex(/^bpc_[A-Za-z0-9]+$/);
